import React from "react";
import tw from "twin.macro";

const FileIcons = new Map([["application/pdf"]]);

const AttachmentLink = tw.a`flex gap-4 items-center text-blue-800 text-lg mt-2`;

export function AttachmentsBlock({ url, originalFilename }) {
	return (
		<AttachmentLink href={url}>
			<p>{originalFilename}</p>
		</AttachmentLink>
	);
}
